import Vue from 'vue';
import Router, {Route} from 'vue-router';
import Home from '../components/views/Home.vue';
import {Position} from 'vue-router/types/router';
import i18n, {loadLanguageAsync} from '@/i18n';
import {SET_LAYOUT_CONFIG, SET_LOADING} from '@/store/layout_module';
import store, {SET_LANGUAGE, SET_TOKEN} from '@/store';
import NotFound from '@/components/views/NotFound.vue';
import Error from '@/components/views/Error.vue';
import dashboardChildren from '@/router/dashboard_children';
import axios from 'axios';
import bookletsChildren from '@/router/booklets_children';

// @ts-ignore
import { page } from 'vue-analytics';


Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to: Route, from: Route, savedPosition: void | Position) {
    if (savedPosition) {
      return savedPosition;
    } else {
      if (to.hash) {
        return {
          selector: to.hash
          // , offset: { x: 0, y: 10 }
        };
      } else {
        return {x: 0, y: 0};
      }
    }
  },



  routes: [
    /**
     * Homepage - displays bad entry message, as the default entry page is through /:lang/:token
     */
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        pageTitleConfig: {
          showPageTitle: false,
          showBackButton: false,
          pageTitle: '',
          pageTitleParams: null,
          backButtonLink: '',
          showFooterNav: false
        }
      }
    },

    /**
     * Default entry page - processes the token and sets user data into the store
     */
    {
      name: 'participantHome',
      path: '/psp/:token',
      component: () => import(/* webpackChunkName: "dashboard" */ '../components/views/dashboard/Dashboard.vue'),
      props: true,
      children: dashboardChildren,
    },

    /**
     * Booklets
     */
    {
      path: '/booklets',
      component: () => import(/* webpackChunkName: "booklets" */ '../components/views/booklets/BookletsWrapper.vue'),
      props: true,
      children: bookletsChildren,
    },

    /**
     * Not Found - any other route
     */

    {
      path: '*',
      name: 'notfound',
      component: NotFound,
      meta: {
        pageTitleConfig: {
          showPageTitle: false,
          showBackButton: false,
          pageTitle: '',
          pageTitleParams: null,
          backButtonLink: null,
          showFooterNav: false
        }
      }
    },
  ],
});


router.beforeEach((to: Route, from: Route, next: any) => {
  if (to.params.lang) {
    loadLanguageAsync(to.params.lang).then(() => next()).catch((error) => {
      next({path: '/not-found'});
    });
  } else {
    loadLanguageAsync(i18n.locale).then(() => next()).catch((error) => {
      next({path: '/not-found'});
    });
  }
})

/**
 * After each route adjust the layout settings based on route meta data
 */
router.afterEach((to: Route, from: Route) => {
  store.commit('layout/' + SET_LAYOUT_CONFIG, to.meta.pageTitleConfig);
  if (to.name !== 'participantHome') {
    // page(to.fullPath);
  }
})

export default router;
